module.exports = __webpack_public_path__ + "static/media/portfolio.bcab92db.png";